module.exports = __webpack_public_path__ + "static/sumergible_2-5af7d9fe4b182585805dc1af89d82f39.png";